import { useQuery } from '@apollo/client';
import type { DealFetchRes } from '@openx/components-deal/lib/utils/context/DealHookTypes.ts';
import type { DealApi, DealOaApi } from '@openx/types/deal.ts';
import { GetDealDocument } from '../../../graphql/query/deals/GetDeal.generated.tsx';
import { formatDeal } from '../../../modules/deals/utils/formatDeal.ts';

export const useDealFetch = <T extends DealApi = DealOaApi>(dealUid: string): DealFetchRes<T> => {
  const {
    data: { dealById: dealRaw } = {},
    loading,
    refetch,
  } = useQuery(GetDealDocument, { skip: !dealUid, variables: { id: dealUid } });

  return {
    deal: formatDeal(dealRaw),
    loading,
    refetch,
  };
};
